import api from '../../utils/api';

const API_BASE_URL = "/admin/ADPRefgroup"; // Adjust to match your backend API

const ADPRefgroupService = {
  async findAll(): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all`);
    return response.data;
  },

  async getItemById(moduleId: string, referenceGroup: string,): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one/${moduleId}/${referenceGroup}`);
    return response.data;
  },

  async create(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/create`, item);
    return response.data;
  },

  async update(moduleId: string, referenceGroup: string, item: any): Promise<any> {
    const response = await api.put(`${API_BASE_URL}/update/${moduleId}/${referenceGroup}`, item);
    return response.data;
  },

  async delete(moduleId: string, referenceGroup: string,): Promise<any> {
    const response = await api.delete(`${API_BASE_URL}/delete/${moduleId}/${referenceGroup}`);
    return response.data;
  },
};



export default ADPRefgroupService;